import React from 'react'
import { Drawer } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { stringifyDate, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'
import Confirm from '../reusable/confirm'

// Lean counterpart to sentMedication.js, scoped to optical dispensing - lists an order's
// items and lets staff issue/return them via the same generic issuePrescription/
// returnPrescription endpoints Pharmacy uses. Deliberately doesn't carry sentMedication's
// FEFO batch-override picker (its pharmacyStoreId/medicationGroup lookups are hardcoded
// to Pharmacy throughout - generalizing that safely is separate scope); issuing here
// relies on the backend's automatic store/batch resolution.
const OpticalDispense = ({ source, onPerform }) => {
    const { id } = useParams()
    const history = useHistory()
    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error, data: order }, refetch] = usePet('order', { id }, { notify: true })

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    const onComplete = (_, notif, ops) => {
        onPerform()
        refetch()
        notif('Changes have been saved', ops('success'))
    }

    const [{ loading: issueLoading }, issuePrescription] = usePet('issuePrescription', {}, { notify: true, callback: onComplete, manual: true })
    const [{ loading: returnLoading }, returnPrescription] = usePet('returnPrescription', {}, { notify: true, callback: onComplete, manual: true })

    const issue = item => Confirm({
        title: 'Issue Item?',
        message: `This will issue "${item?.ref?.name}" to ${order?.patient?.name} and update optical inventory accordingly.`,
        okText: 'Issue Item',
        onOk: () => issuePrescription({ id: item._id }),
    })

    const doReturn = item => Confirm({
        title: 'Return Item?',
        message: `This will return "${item?.ref?.name}" and restore optical inventory accordingly.`,
        okText: 'Return Item',
        onOk: () => returnPrescription({ id: item._id }),
    })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width={700}>
            <Receive error={error} loading={loading} progress>
                <p className="font-extrabold text-3xl mb-0">Optical Dispensing</p>
                <p className="text-gray-500 text-xs italic mb-3">{order?.patient?.name ?? 'Patient'}'s visit {order?.date && `on ${stringifyDate(order?.date)}`}</p>

                <table className="table-auto w-full">
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                            <th className="p-2"><div className="font-semibold text-left">Item</div></th>
                            <th className="p-2"><div className="font-semibold text-center">Quantity</div></th>
                            <th className="p-2"><div className="font-semibold text-center">Status</div></th>
                            <th className="p-2"><div className="font-semibold text-center"></div></th>
                        </tr>
                    </thead>
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                        {
                            (order?.items ?? []).map((item, key) =>
                                <tr key={ item._id ?? key }>
                                    <td className="p-2">{ item?.ref?.name }</td>
                                    <td className="p-2"><div className="text-center">{ item?.quantity }</div></td>
                                    <td className="p-2"><div className="text-center">{ item?.served ? 'Issued' : 'Pending' }</div></td>
                                    <td className="p-2 text-center">
                                        {
                                            item?.served ?
                                                <button disabled={returnLoading} onClick={ () => doReturn(item) } className="text-white bg-gray-500 hover:bg-gray-600 font-medium rounded-lg text-sm px-4 py-2 text-center">Return</button>
                                                :
                                                <button disabled={issueLoading} onClick={ () => issue(item) } className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-4 py-2 text-center">Issue</button>
                                        }
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Receive>
        </Drawer>
    )
}

export default OpticalDispense
